import { t } from 'i18next';
import { ReactComponent as LikeLineIcon } from '../../icons/like.line.svg';
import { ReactComponent as LikeGradientShape } from '../../icons/likeGradientShape.svg';
import { ReactComponent as MapFillIcon } from '../../icons/map.fill.svg';
import { ICoordinates } from '../../types/types';
import moveKakaoMap from '@pocapan/shared/utils/moveKakaoMap';
import PrimaryButton from '../buttons/PrimaryButton';
import ToggleLikeLocation from '../api/mutations/ToggleLikeLocation';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface LocationBottomBarProps {
  locationId: string;
  locationName: string;
  locationAddress: string;
  coordinates: ICoordinates;
  kakaoMapUID: string | null;
  isLiked: boolean;
  onLikedLocation?: (liked: boolean) => void;
}

const LocationBottomBar = ({
  locationId,
  locationName,
  locationAddress,
  coordinates,
  kakaoMapUID,
  isLiked,
  onLikedLocation
}: LocationBottomBarProps) => {
  const navigate = useNavigate();

  const [liked, setLiked] = useState<boolean>(isLiked);

  const handleLikeLocation = async () => {
    const response = await ToggleLikeLocation(locationId);
    const data = await response.json();

    if (response?.ok) {
      const responseLiked = data?.location?.isLiked;
      setLiked(responseLiked);
      onLikedLocation?.(responseLiked);
    }
  };

  const navigateToLocationDetail = () => {
    if (window.location.pathname === `/locations/${locationId}`) return;
    navigate(`/locations/${locationId}`);
  };

  return (
    <div
      className="fixed max-width-container z-[1000] bottom-0 w-full pt-[18px] pb-[calc(env(safe-area-inset-bottom)+19px)] px-[20px] bg-backgroundElevated-light dark:bg-backgroundElevated-dark"
      style={{ filter: 'drop-shadow(rgba(0, 0, 0, 0.1) 0px 0px 15px)' }}
    >
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col max-w-[calc(100%-128px)]" onClick={navigateToLocationDetail}>
          <div className="flex flex-row items-center ml-[-2px] gap-[2px] text-[17px] leading-[17px] font-semibold text-main-light-2 dark:text-main-dark-2">
            <MapFillIcon className="w-[18px] h-[18px] mb-[1px]  fill-onTheirty-light dark:fill-onTheirty-dark" />
            <div className="truncate">{locationName}</div>
          </div>
          <div className="flex mt-[5px] text-[13px] leading-[16px] text-main-light-4 dark:text-main-dark-4">
            {locationAddress}
          </div>
        </div>
        <div className="flex flex-row items-center gap-[8px]">
          <PrimaryButton
            text={`${t('OfflineLocationDetail.openMap2')}`}
            paddingX={'18px'}
            paddingY={'12px'}
            maxHeight={'40px'}
            disabled={false}
            icon={null}
            onClick={() => moveKakaoMap(coordinates.lat, coordinates.lng, kakaoMapUID)}
          />
          <div
            className="w-[40px] h-[40px] rounded-full p-[11px] bg-secondary-light dark:bg-secondary-dark"
            onClick={() => handleLikeLocation()}
          >
            {liked ? (
              <LikeGradientShape width={'18px'} height={'18px'} />
            ) : (
              <LikeLineIcon
                className="fill-primary-light dark:fill-primary-dark"
                width={'18px'}
                height={'18px'}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationBottomBar;
